

export const ColorPalette = {
    mainColor: "#056674",
    secondaryColor: "#FF4B5C",
    thirdColor: "#FF4B5C",
    highlight: "#66BFBF",
    red: "#fd4431",
    green: "#09D766",
    fontGreen: "#378805",
    backgroundColor:'white',
    navFontColor: 'white',
    gray: '#a0a0a0'
}



//     {
//     mainColor: "#0070b5",
//     secondaryColor: "#49b7e9",
//     thirdColor: "#8681e8",
//     highlight: "#fe89be",
//     red: "#fd4431",
//     green: "#09D766"
// }